import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Network } from '@ionic-native/network';
import { Platform } from 'ionic-angular';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

/*
  Generated class for the NetworkConnectionProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
declare var Connection;

@Injectable()
export class NetworkConnectionProvider {

  //Variabile indica se la nostra connessione e' attiva o meno
  private isConnect: boolean;
  //verifica se siamo su browser o dispositivo mobile
  private isDevice: boolean;

  private isOnline: BehaviorSubject<boolean>;

  constructor(public http: Http, private network: Network, private platform: Platform) {
    this.getConnection(); //verifico la connessione
    this.isDevice = this.platform.is('mobile');

    ////console.log('Hello NetworkConnectionProvider Provider, we are connected? '+ this.network.type);
  }

  /**
 * Metodo che si mette in ascolto di cambiamenti nella connessione
 * permette di abilitare\disabilitare alcune funzionalità dell'app
 */
  private getConnection() {


    //check if is mobile device or not, on browser use navigator.online property
    if (!this.isDevice)
      this.isConnect = navigator.onLine;
    else
      this.isConnect = this.network.type !== Connection.NONE ? true : false;

    this.isOnline = new BehaviorSubject(this.isConnect);

    // watch network for a disconnect
    this.network.onDisconnect().subscribe(() => {
      //console.log('network was disconnected :-(');
      this.isConnect = false;
      this.isOnline.next(false);
    });

    // watch network for a connection
    this.network.onConnect().subscribe(() => {
      //console.log('network connected!');
      this.isConnect = true;
      this.isOnline.next(true);
    });

  }

  checkConnection(): BehaviorSubject<boolean> {
    return this.isOnline;
  }

  /**
   * Metodo di verifica della connessione, 
   * restituisce true se attiva, false altrimenti
   */
  verifyConnection(): boolean {
    return this.isConnect;
  }

  /**
   * Restituisce il tipo di connessione, se presente
   */
  getTypeConnection(): string {
    return this.network.type;
  }


}



// WEBPACK FOOTER //
// ./src/providers/network-connection/network-connection.ts